// eslint-disable-next-line import/prefer-default-export
export const getDefaultAuthHeaders = (token = '') => {
  if (!token) throw new Error('Token invalid');
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  return headers;
};
